import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fi-checklist-checkpoint-answer-view-state',
    templateUrl: './checkpoint-answer-view-state.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./checkpoint-answer-view-state.component.scss'],
    standalone: false,
})
export class FiChecklistCheckpointAnswerViewStateComponent {
    @Input() checklistViewer;
    @Input() checklist;
}
